import { get, post } from '../../config/$ajax.js'

// 获取铺货日志列表
export const publishLog = (data = {})=> {
  return post('/logging/publishLog', data, {submitType: 'json', isNeedLoading: true })
}
// 获取铺货日志列表（商品维度）
export const platformProductPublishLog = (data = {})=> {
  return post('/logging/platformProductPublishLog', data, {submitType: 'json',isNeedLoading: true })
}
// 获取商品日志-商品修改日志列表
export const productEditLogPage = (data = {})=> {
  return post('/logging/productEditLogPage', data, {submitType: 'json',isNeedLoading: true })
}
// 获取商品日志-商品修改日志详情
export const productEditLogDetail = (data = {})=> {
  return post('/logging/productEditLogDetail', data, {})
}

// 获取日志详情
export const publishLogDetail = (data = {})=> {
  return get('/logging/publishLogDetail', data, {isNeedLoading: false })
}
// 获取日志详情(商品维度)
export const platformProductPublishLogDetail = (data = {})=> {
  return get('/logging/platformProductPublishLogDetail', data, {isNeedLoading: false })
}

/**
 * 获取商品byid日志详情
 */
 export const publishLogById = function(data = {}) {
  return get('/logging/publishLogById', data, {isNeedLoading: false})
}
/**
 * 获取商品byid日志详情(商品维度)
 */
 export const platformProductPublishLogById = function(data = {}) {
  return get('/logging/platformProductPublishLogById', data, {isNeedLoading: false})
}

// 获取操作日志列表
export const operatorLog = (data = {})=> {
  return post('/logging/operatorLog', data, {submitType: 'json', isNeedLoading: true })
}
// 终止铺货任务
export const stopTask = (data = {})=> {
  return post('/taskScheduling/stopTask', data, {submitType: 'json', isNeedLoading: true })
}
// 获取当前商品审核中的图片信息
export const queryLogItemImages = (data = {})=> {
  return post('/logging/queryItemImages', data, {submitType: 'json', isNeedLoading: true })
}

// 根据日志类型查询对应的途径
export const queryChannelByType = (data = {})=> {
  return get('/logging/queryChannelByType', data, {isNeedLoading: false })
}

// 获取操作日志详情
export const operatorLogDetail = (data = {})=> {
  return get('/logging/operatorLogDetail', data, {isNeedLoading: true })
}

// 查询操作日志详情【sku】维度
export const operatorSkuLogDetail = (data = {})=> {
  return get('/logging/operatorSkuLogDetail', data, {isNeedLoading: true })
}

// 获取货源提报列表
export const goodsLog = (data = {})=> {
  return post('/logging/baseItemOcenRecord', data, {submitType: 'json', isNeedLoading: true })
}